<template>
  <svg
    width="16"
    height="11"
    viewBox="0 0 16 11"
  >
    <path d="M1 2C1 0.895431 1.89543 0 3 0H13C14.1046 0 15 0.89543 15 2V7C15 8.10457 14.1046 9 13 9H3C1.89543 9 1 8.10457 1 7V2ZM3 1C2.44772 1 2 1.44772 2 2V7C2 7.55228 2.44772 8 3 8H13C13.5523 8 14 7.55228 14 7V2C14 1.44772 13.5523 1 13 1H3ZM0 10.5C0 10.2239 0.223858 10 0.5 10H15.5C15.7761 10 16 10.2239 16 10.5C16 10.7761 15.7761 11 15.5 11H0.5C0.223858 11 0 10.7761 0 10.5Z" />
  </svg>
</template>
